import { OverlayContainer } from "@angular/cdk/overlay";

export class CustomOverlayContainer extends OverlayContainer {
  constructor(private selector: string) {
    super();
  }

  /**
   * The CDK caches the container element for the lifetime of the service. That
   * breaks as soon as the host element addressed by `selector` is removed from
   * the DOM — e.g. `.pia-overlay` lives inside the app shell, which is torn
   * down and rebuilt while the navigation reloads after a country change. The
   * cached container goes with it and every later overlay (menus, dialogs)
   * would be appended to a detached node: invisible, no backdrop, nothing
   * happens. So drop a disconnected container and build a fresh one.
   */
  override getContainerElement(): HTMLElement {
    if (this._containerElement && !this._containerElement.isConnected) {
      this._createContainer();
    }
    return super.getContainerElement();
  }

  protected override _createContainer(): void {
    const container = document.createElement("div");
    container.classList.add("cdk-overlay-container");

    const parent = document.querySelector(this.selector) ?? document.body;
    parent.appendChild(container);

    this._containerElement = container;
  }
}
